/*----- Desktop Searchbar Close Adjustment -----*/

// Mutation Observer with a function to a certain element
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(() => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// Checking if the PFS search button exists, which means PFS is fully loaded
waitForElm('.boost-pfs-search-btn-close-suggestion').then(() => {
    let desktopSearchBar = document.querySelector('.searchBarDesktop');
    let mobileSearchBar = document.querySelector('.searchBarMobile');

    desktopSearchBar.classList.add('searchBarDesktop--shown');
    mobileSearchBar.classList.add('searchBarMobile--shown')
});